<template>
  <div class="special-page">
    <div class="client-app-inc" style="min-height:200px" v-if="isLoading">
        <Loader style="margin-top:30px"></Loader>
    </div>
    <div class="top-menu" v-if="!isMobile && !isLoading">
      <ul>
        <li v-for="(item, key) in pages" :key="key"><router-link :to="{ name: 'Page', params:{slug: item.url} }">{{ item.title }}</router-link></li>
      </ul>
    </div>
    <div class="container" v-if="!isLoading">
      <div class="panel special-panel">
        <div class="title">{{ page.title }}</div>
        <div class="content">
            <content v-html="page.content"></content>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'Page',
        data() {
            return {
                slug: this.$route.params.slug,
                page: null,
                isLoading: false,
            }
        },
        metaInfo () {
            return {
                title: _.get(this.page, 'title', '') + ' | ' + _.get(this.$store.getters['getClientMeta'], 'main.title', ''),
            }
        },
        computed: {
            pages: function() {
                return this.$store.getters.getClientPages;
            },
        },
        created() {
            this.loadPage(this.slug);
        },
        watch: {
            '$route.params.slug': function(slug) {
                if ((_.includes(this.$route.fullPath, '/page'))) {
                    this.loadPage(slug);
                }
            }
        },
        methods: {
            loadPage: function(slug) {
                this.isLoading = true;
                axios.get('page/' + slug)
                    .then((response) => {
                        this.page = response.data;
                        this.isLoading = false;
                        //this.$root.setMeta('page', {title: this.page.title, keywords: this.page.keywords});
                        //this.$forceUpdate();

                    })
                    .catch((err) => {
                        if (err.response.status === 404) {
                            this.$router.push({name: 'NotFound'});
                       }
                    });
            },
        },
    }
</script>